import TrophyBadge from './TrophyBadge';
import {
  ItemWrapper,
  ItemHeader,
  CategoryName,
  CounterWrapper,
  CountAcquired,
  CountSeparator,
  CountTotal,
  ProgressBarWrapper,
  Track,
  Fill,
  TrophyMarker,
} from './styled-components';

const CategoryProgressItem = ({
  name,
  acquired = 0,
  total = 1,
  categoryId,
  trophyProgressBarColor = 'empty',
  onClick,
}) => {
  const progressValue = total > 0 ? (acquired / total) * 100 : 0;
  const trophySize = 36;
  const trophyLeft = `clamp(0px, calc(${progressValue}% - ${trophySize / 2}px), calc(100% - ${trophySize}px))`;

  return (
    <ItemWrapper $clickable={!!onClick} onClick={onClick}>
      <ItemHeader>
        <CategoryName>{name}</CategoryName>
        <CounterWrapper>
          <CountAcquired>{acquired}</CountAcquired>
          <CountSeparator>/</CountSeparator>
          <CountTotal>{total}</CountTotal>
        </CounterWrapper>
      </ItemHeader>

      <ProgressBarWrapper>
        <Track>
          <Fill $width={progressValue} />
        </Track>

        {categoryId && (
          <TrophyMarker $left={trophyLeft}>
            <TrophyBadge categoryId={categoryId} trophyColor={trophyProgressBarColor} bodyWidth={32} />
          </TrophyMarker>
        )}
      </ProgressBarWrapper>
    </ItemWrapper>
  );
};

export default CategoryProgressItem;
